enum AcceptRejectView {
  Horizontal,
  Vertical,
}

export default AcceptRejectView;
